exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".order-details-container {\n  padding: 20px; }\n  .order-details-container .order-details-title {\n    margin-bottom: 20px; }\n\n.order-details-main {\n  position: relative; }\n  .order-details-main .print {\n    position: absolute;\n    top: 20px;\n    right: 20px; }\n", ""]);

// exports
